import { ILoginCardProps } from './loginCard.models';
import { purify } from '@vfit/shared/themes';
import { useMemo } from 'react';

export const useLoginCard = (props: ILoginCardProps) => {
  const description = useMemo(() => purify([props.description])[0] || '', [props.description]);
  const title = useMemo(() => purify([props.title])[0] || '', [props.title]);

  return {
    description,
    title,
    url: props.url || '',
  };
};

